import React, { Component } from 'react'
import { Button, ButtonGroup, Grid, Row, Col, Glyphicon } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { fetchData } from '../../common/redux/collectionActions'
import CarrierDeliveriesContainer from './Deliveries/DeliveriesContainer'
import CarrierDriverContainer from './Driver/DriverContainer'
import CreateDeliveryModal from './Deliveries/CreateDeliveryModal'
import TerminalContainer from './Terminal/TerminalContainer'
import SubadminContainer from './Subadmin/SubadminContainer'
import MapViewers from './MapViewers/MapViewerContainer'
import ExploringContainer from './Exploring/ExploringContainer'
import Statistics from '../Statistics/Statistics'

const activeTabColor = 'rgba(0, 110, 120, 0.5)'

class CarrierContainer extends Component {
  state = {
    modalOpen: null,
  }

  componentDidMount() {
    const { admin } = this.props
    if (admin.type !== 'c_terminal') {
      this.props.fetchData(['c_terminals'])
    }
  }

  renderContainer = (selectedContainer) => {
    const { terminals, drivers } = this.props

    if (selectedContainer === 'drivers') return <CarrierDriverContainer terminals={terminals} drivers={drivers} />

    if (selectedContainer === 'terminals') return <TerminalContainer terminals={terminals} drivers={drivers} />

    if (selectedContainer === 'subadmins') return <SubadminContainer terminals={terminals} />

    if (selectedContainer === 'mapViewers') return <MapViewers />

    if (selectedContainer === 'deliveries') return <CarrierDeliveriesContainer />

    if (selectedContainer === 'exploring') return <ExploringContainer />

    if (selectedContainer === 'statistics') return <Statistics />
  }

  select = ({ target: { name } }) => {
    const { history } = this.props
    history.push(`/carrier/${name}`)
  }

  render() {
    const { modalOpen } = this.state
    const { admin, location } = this.props

    const selectedContainer = location.pathname.split('/').slice(-1)[0] || 'drivers'

    return (
      <Grid style={{ width: '100%' }}>
        {modalOpen === 'CreateDelivery' && <CreateDeliveryModal closeModal={() => this.setState({ modalOpen: null })} modalIsOpen={modalOpen === 'CreateDelivery'} />}
        <Row>
          <Col sm={12}>
            <ButtonGroup style={{ paddingBottom: 30, justifyContent: 'center', display: 'flex', width: '100%' }}>
              <Button style={{ flex: 1, background: selectedContainer === 'drivers' ? activeTabColor : '' }} name="drivers" onClick={this.select}>
                Chaufförer
              </Button>
              {admin.type !== 'c_terminal' && (admin.user.subadmins || admin.type === 'subadmin') && (
                <Button style={{ flex: 1, background: selectedContainer === 'terminals' ? activeTabColor : '' }} name="terminals" onClick={this.select}>
                  Åkeriadmin
                </Button>
              )}
              {admin.type === 'carrier' && admin.user.subadmins && (
                <Button style={{ flex: 1, background: selectedContainer === 'subadmins' ? activeTabColor : '' }} name="subadmins" onClick={this.select}>
                  Lokaladmin
                </Button>
              )}
              {admin.type === 'carrier' && /schenker/i.test(admin.user.organization) && (
                <Button style={{ flex: 1, background: selectedContainer === 'mapViewers' ? activeTabColor : '' }} name="mapViewers" onClick={this.select}>
                  Kart-och leveranstillgångar
                </Button>
              )}
              <Button style={{ flex: 1, background: selectedContainer === 'deliveries' ? activeTabColor : '' }} name="deliveries" onClick={this.select}>
                Leveranser
              </Button>
              <Button style={{ flex: 1, background: selectedContainer === 'exploring' ? activeTabColor : '' }} name="exploring" onClick={this.select}>
                Utforska
              </Button>
              {admin.type === 'carrier' && (
                <Button style={{ flex: 1, background: selectedContainer === 'statistics' ? activeTabColor : '' }} name="statistics" onClick={this.select}>
                  Statistik
                </Button>
              )}
            </ButtonGroup>
          </Col>
        </Row>
        {admin.user.settings && admin.user.settings.k2enabled && false && (
          <Row style={{ marginBottom: 40 }}>
            <Col md={4} lg={4}>
              &nbsp;
            </Col>
            <Col xs={4} md={4} lg={4}>
              <ButtonGroup>
                <Button onClick={() => this.setState({ modalOpen: 'CreateDelivery' })} className="add-lock-btn" bsSize="small" block>
                  <Glyphicon glyph="glyphicon glyphicon-pencil" /> &nbsp; Skapa leverans
                </Button>
              </ButtonGroup>
            </Col>
            <Col md={4} lg={4}>
              &nbsp;
            </Col>
          </Row>
        )}
        <Row>
          <Col xs={12} md={12} lg={12}>
            {this.renderContainer(selectedContainer)}
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapProps = (state) => ({
  admin: state.collectionData.admin,
  drivers: state.collectionData.drivers,
  events: state.collectionData.events,
  terminals: state.collectionData.terminals,
})

const mapDispatch = (dispatch) => ({
  fetchData: (cols) => dispatch(fetchData(cols)),
})

export default connect(
  mapProps,
  mapDispatch
)(withRouter(CarrierContainer))
